export default () => {
  const form = $('.searcherform');
  const input = $(".btn-searcher input[type='text']");

  $('.btn-searcher button').on('click', () => {
    input.addClass('active-input');
    form.addClass('active-searcher');
    $('.btn-close-searcher').css('display', 'flex');
  });

  input.on('click', () => {
    form.addClass('focus-searcher');
    $('.btn-searcher button').attr('type', 'submit');
  });

  input.on('focusout', () => {
    form.removeClass('focus-searcher');
  });

  $('.btn-close-searcher').on('click', () => {
    input.removeClass('active-input');
    form.removeClass('active-searcher');
    $(this).hide();
    $('.btn-searcher button').attr('type', 'button');
  });

  form.on('submit', (e) => {
    e.preventDefault();

    const el = $(e.target);
    const searchTerm = el.find('input').val();
    if (!searchTerm) {
      if (!el.hasClass('searcherform--mobile')) {
        el
          .find('input')
          .attr('placeholder', 'Introduce una palabra a buscar');
      }
      return;
    }

    const eventData = {
      search_term: searchTerm,
    };
    window.dataLayer.push({ event: 'search', eventData });

    const path = el.data('url');
    window.location.href = path + searchTerm;
  });
};
